/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export enum PartialRestoreType {
  FilesPartialRestoreData = 'FILES_PARTIAL_RESTORE_DATA',
  AwsEbsVolumePartialRestoreData = 'AWS_EBS_VOLUME_PARTIAL_RESTORE_DATA',
  AzureDiskPartialRestoreData = 'AZURE_DISK_PARTIAL_RESTORE_DATA',
  GcpDiskPartialRestoreData = 'GCP_DISK_PARTIAL_RESTORE_DATA'
}
